(() => {
  const CARD_SELECTOR = 'product-card-atc';

  const findAll = (root, selector) => {
    const found = Array.from(root.querySelectorAll(selector));
    if (root.matches && root.matches(selector)) {
      found.unshift(root);
    }
    return found;
  };

  // Applies the collection ATC variation to every button found inside `root`.
  // `root` can be the document or any element (e.g. a product card inserted later).
  const applyCollectionAtcVariation = (root, variation) => {
    findAll(root, '.quick-view-trigger-wrapper').forEach((el) => el.classList.add('none'));
    findAll(root, '.plp-atc-cta-b').forEach((el) => el.classList.add('none'));

    if (variation === "VARIATION-1") {
      findAll(root, '.plp-atc-cta-b').forEach((el) => el.classList.remove('none'));
    }
  };

  // Product cards can be re-rendered after load (color swatch change via section
  // rendering, filters, pagination). The new markup comes from Liquid with the
  // buttons hidden, so the active variation must be re-applied to those cards.
  let activeVariation = null;
  let cardObserver = null;

  const observeNewCards = () => {
    if (cardObserver) {
      return;
    }

    cardObserver = new MutationObserver((mutations) => {
      if (!activeVariation) {
        return;
      }

      mutations.forEach((mutation) => {
        mutation.addedNodes.forEach((node) => {
          if (node.nodeType !== Node.ELEMENT_NODE) {
            return;
          }

          const isCard = node.matches(CARD_SELECTOR);

          if (isCard || node.querySelector(CARD_SELECTOR)) {
            applyCollectionAtcVariation(node, activeVariation);
          }
        });
      });
    });

    cardObserver.observe(document.body, { childList: true, subtree: true });
  };

  const setCollectionAtcPLP = () => {
    const isHoldoutGroup = window._growthbook?.getFeatureValue(
      "holdout-q3-littletrouble",
      "OFF"
    );

    if (isHoldoutGroup === "holdout-q3-2026") {
      return;
    }

    const isCollectionAtcEnabled = window._growthbook?.getFeatureValue(
      "collection-page-atc-littletrouble",
      "OFF"
    );

    if (isCollectionAtcEnabled === "OFF") {
      activeVariation = null;
      return;
    }

    activeVariation = isCollectionAtcEnabled;
    applyCollectionAtcVariation(document, activeVariation);
    observeNewCards();
  };

  const setNavRestructure = () => {
    const isHoldoutGroup = window._growthbook?.getFeatureValue(
      "holdout-q3-littletrouble",
      "OFF"
    );

    if (isHoldoutGroup === "holdout-q3-2026") {
      return;
    }

    const isValueMenu = window._growthbook?.getFeatureValue(
      "menu-littletrouble",
      false
    );

    if (!isValueMenu) {
      return;
    }

    const controlSelectors = [".nav-ab-control", ".menu-version.nav-mobile-ab-control"];
    const variantSelectors = [".nav-ab-variant", ".menu-version.nav-mobile-ab-variant"];

    controlSelectors.forEach((selector) => {
      document.querySelectorAll(selector).forEach((el) => {
        el.classList.add("hide");
      });
    });

    variantSelectors.forEach((selector) => {
      document.querySelectorAll(selector).forEach((el) => {
        el.classList.remove("hide");
      });
    });
  };

  window.growthbook_queue = window.growthbook_queue || [];
  window.growthbook_queue.push((gb) => {
    // Function that uses feature flags to make changes to the page
    const applyFeatureFlags = () => {
      setCollectionAtcPLP();
      setNavRestructure();
    };

    // Call your function initially plus whenever new data is received
    applyFeatureFlags();
    document.addEventListener("growthbookdata", applyFeatureFlags);
  });
})();
